import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData,patchData ,updateData} from "../../../services/api";
import { toast } from 'react-toastify';

// Get suspicious list
export const suspisiousLisitingRequest = (page = 1, pageSize = 10) => {
  return async (dispatch) => {
    const url = `${ApiURLs.SUSPISIOUS}?page=${page}&limit=${pageSize}`;
    dispatch({ type: "GET_SUSPISIOUS_REQUEST" });

    try {
      const suspisiousData = await fetchData(url);
      if (suspisiousData.status === 1) {
        dispatch({
          type: "GET_SUSPISIOUS_REQUEST_SUCCESS",
          payload: suspisiousData.data.result || [],
          total: suspisiousData.data.total || 0,
        });
      } else {
        dispatch({ type: "GET_SUSPISIOUS_REQUEST_FAILED" });
      }
    } catch (error) {
      console.error("Fetch suspicious error:", error);
      dispatch({ type: "GET_SUSPISIOUS_REQUEST_FAILED" });
    }
  };
};

// Delete suspicious records by activity IDs
export const deleteSuspisious = (activityIds) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_SUSPISIOUS_REQUEST" });

    try {
      const idsAsString = Array.isArray(activityIds) ? activityIds.join(",") : activityIds;
      const url = `${ApiURLs.SUSPISIOUS}?activity_ids=${idsAsString}`;
      const response = await deleteData(url);

      if (response.status === 1) {
        dispatch({ type: "DELETE_SUSPISIOUS_SUCCESS" });
        dispatch(suspisiousLisitingRequest()); // Refresh the list
      } else {
        dispatch({ type: "DELETE_SUSPISIOUS_FAILED" });
      }
    } catch (error) {
      console.error("Delete suspicious error:", error);
      dispatch({ type: "DELETE_SUSPISIOUS_FAILED" });
    }
  };
};




export const blockUser = (id) => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "DELETE_SUSPISIOUS_REQUEST" });
    try {
      var planResponse = await patchData(`${ApiURLs.GET_USERS}/${id}`);
      if (planResponse.status === 1) {
        dispatch({ "type": "ADD_SUSPISIOUS_SUCCESS" });
        dispatch(suspisiousLisitingRequest());
      } else {
        dispatch({ "type": "ADD_SUSPISIOUS_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_SUSPISIOUS_FAILED" });

    }
  };
};


  export const blockAd = (data) => {
    return async (dispatch) => {
      dispatch({"type":"ADD_SUSPISIOUS_REQUEST"});
      try {
        var adReportResponse = await updateData({body:data}, `${ApiURLs.ADS}/${data.id}`);
        if (adReportResponse.status === 1) {
          toast.success("Ad blocked successfully");
          dispatch({"type":"ADD_SUSPISIOUS_SUCCESS"});
          dispatch(suspisiousLisitingRequest());
        } else {
          dispatch({"type":"ADD_SUSPISIOUS_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_SUSPISIOUS_FAILED"});
  
      }
    };
  };
      
